export const CLEAR_STATE = "CLEAR_STATE";
export const TOGGLE_SOCKET_LISTENING_PLANNING = "TOGGLE_SOCKET_LISTENING_PLANNING";
export const CACHE_ADD_PLAN = "CACHE_ADD_PLAN";

export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLANS_FAIL = "GET_PLANS_FAIL";

export const DELETE_PLAN = " DELETE_PLAN";
export const DELETE_PLAN_SUCCESS = " DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_FAIL = "DELETE_PLAN_FAIL";

export const UPDATE_PLAN = " UPDATE_PLAN";
export const UPDATE_PLAN_SUCCESS = " UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_FAIL = "UPDATE_PLAN_FAIL";

export const RESTORE_PLAN = "RESTORE_PLAN";
export const RESTORE_PLAN_FAIL = "RESTORE_PLAN_FAIL";
export const RESTORE_PLAN_SUCCESS = "RESTORE_PLAN_SUCCESS";

export const RESTORE_DRIVER = "RESTORE_DRIVER";
export const RESTORE_DRIVER_FAIL = "RESTORE_DRIVER_FAIL";
export const RESTORE_DRIVER_SUCCESS = "RESTORE_DRIVER_SUCCESS";

export const ERROR_PLAN_MESSAGE = " ERROR_PLAN_MESSAGE";
export const ERROR_PLAN_MESSAGE_SUCCESS = " ERROR_PLAN_MESSAGE_SUCCESS";
export const ERROR_PLAN_MESSAGE_FAIL = "ERROR_PLAN_MESSAGE_FAIL";

export const CREATE_PLAN = "CREATE_PLAN";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_FAIL = "CREATE_PLAN_FAIL";

export const DOWNLOAD_OPTIMIZE_FILE = "DOWNLOAD_OPTIMIZE_FILE";
export const DOWNLOAD_OPTIMIZE_FILE_SUCCESS = "DOWNLOAD_OPTIMIZE_FILE_SUCCESS";
export const DOWNLOAD_OPTIMIZE_FILE_FAIL = "DOWNLOAD_OPTIMIZE_FILE_FAIL";

export const DOWNLOAD_EXCEL_FILE = "DOWNLOAD_EXCEL_FILE";
export const DOWNLOAD_EXCEL_FILE_SUCCESS = "DOWNLOAD_EXCEL_FILE_SUCCESS";
export const DOWNLOAD_EXCEL_FILE_FAIL = "DOWNLOAD_EXCEL_FILE_FAIL";

export const POST_PLAN_CONFIG = "POST_PLAN_CONFIG";
export const POST_PLAN_CONFIG_SUCCESS = "POST_PLAN_CONFIG_SUCCESS";
export const POST_PLAN_CONFIG_FAIL = "POST_PLAN_CONFIG_FAIL";

export const EXECUTE_PLAN = "EXECUTE_PLAN";
export const EXECUTE_PLAN_SUCCESS = "EXECUTE_PLAN_SUCCESS";
export const EXECUTE_PLAN_FAIL = "EXECUTE_PLAN_FAIL";

export const GET_ALL_PLANS = "GET_ALL_PLANS";
export const GET_ALL_PLANS_SUCCESS = "GET_ALL_PLANS_SUCCESS";
export const GET_ALL_PLANS_FAIL = "GET_ALL_PLANS_FAIL";

export const GET_FROM_EXTERNAL_SOURCE = "GET_FROM_EXTERNAL_SOURCE";
export const GET_FROM_EXTERNAL_SOURCE_SUCCESS = "GET_FROM_EXTERNAL_SOURCE_SUCCESS";
export const GET_FROM_EXTERNAL_SOURCE_FAIL = "GET_FROM_EXTERNAL_SOURCE_FAIL";

export const GET_PLAN_LOGS = "GET_PLAN_LOGS";
export const GET_PLAN_LOGS_SUCCESS = "GET_PLAN_LOGS_SUCCESS";
export const GET_PLAN_LOGS_FAIL = "GET_PLAN_LOGS_FAIL";

export const GET_TOOLNAME_LIST = "GET_TOOLNAME_LIST";
export const GET_TOOLNAME_LIST_SUCCESS = "GET_TOOLNAME_LIST_SUCCESS";
export const GET_TOOLNAME_LIST_FAIL = "GET_TOOLNAME_LIST_FAIL";

export const MISSION_INFO_BY_ORDER_ID = "MISSION_INFO_BY_ORDER_ID";
export const MISSION_INFO_BY_ORDER_ID_SUCCESS = "MISSION_INFO_BY_ORDER_ID_SUCCESS";
export const MISSION_INFO_BY_ORDER_ID_FAIL = "MISSION_INFO_BY_ORDER_ID_FAIL";

export const DOWNLOAD_PLAN_FORM = "DOWNLOAD_PLAN_FORM";
export const DOWNLOAD_PLAN_FORM_SUCCESS = "DOWNLOAD_PLAN_FORM_SUCCESS";
export const DOWNLOAD_PLAN_FORM_FAIL = "DOWNLOAD_PLAN_FORM_FAIL";